import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import {setLookMoreInfoOpened} from "../../../../../actions/lookFunctions";
import {LOOK_FEATURE_CONTENT} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {Look3DIcon} from "../../../../common/icons";
import COLOR_THEMES from "../../../../../colorThemes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const GroheMobile3dButton = (props) => {

  const {lookActiveFeature, intl, setLookMoreInfoOpened, activeTheme, moreInfoOpened, moreInfoContent} = props;

  if (!lookActiveFeature) {
    return null
  }

  const threeDButtonClick = () => {

    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureMobile3dButton
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureMobile3dButton;

    Analytics.sendClickEvent(analyticsLabel);

    const moreInfoType = moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.threeD) ? "" : "main";
    setLookMoreInfoOpened(moreInfoType, LOOK_FEATURE_CONTENT.threeD);
  }

  return (
    <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                disabled={!Array.isArray(lookActiveFeature.dbFeature.lixilAR3DUrls)}
                className="look-icon look-icon--white2 look-icon--disabled-hover"
                onClick={threeDButtonClick}>
      <SvgIcon>
        <Look3DIcon color={COLOR_THEMES[activeTheme].primary} />
      </SvgIcon>
      <span className="gm-icon__text">
        <FormattedMessage id="grohe.mobile.feature.3d"/>
      </span>
    </IconButton>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent} = store.lookState;
  const {activeTheme} = store.serverState;
  return {
    lookActiveFeature,
    moreInfoContent,
    moreInfoOpened,
    activeTheme,
  };
};

const mapDispatchToProps = {
  setLookMoreInfoOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheMobile3dButton)
)
